import { render, staticRenderFns } from "./selectchoice.vue?vue&type=template&id=3f29d506&scoped=true&"
import script from "./selectchoice.vue?vue&type=script&lang=js&"
export * from "./selectchoice.vue?vue&type=script&lang=js&"
import style0 from "./selectchoice.vue?vue&type=style&index=0&id=3f29d506&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f29d506",
  null
  
)

export default component.exports